const STYLES: Record<string, string> = {
  PENDING: 'bg-amber-100 text-amber-800',
  AUTHORIZED: 'bg-blue-100 text-blue-800',
  CAPTURED: 'bg-green-100 text-green-800',
  ABORTED: 'bg-slate-200 text-slate-700',
  EXPIRED: 'bg-slate-200 text-slate-700',
  FAILED: 'bg-red-100 text-red-800',
  REFUNDED: 'bg-purple-100 text-purple-800',
  PARTIALLY_REFUNDED: 'bg-purple-100 text-purple-800',
};

const LABELS: Record<string, string> = {
  PENDING: 'Venter',
  AUTHORIZED: 'Autorisert',
  CAPTURED: 'Betalt',
  ABORTED: 'Avbrutt',
  EXPIRED: 'Utløpt',
  FAILED: 'Feilet',
  REFUNDED: 'Refundert',
  PARTIALLY_REFUNDED: 'Delvis refundert',
};

export function StatusBadge({ status }: { status: string }) {
  const cls = STYLES[status] ?? 'bg-slate-100 text-slate-700';
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${cls}`}>
      {LABELS[status] ?? status}
    </span>
  );
}
